import React from 'react';
import { Badge } from '@/components/ui/badge';
import type { DelegationStatus } from '../types/delegation.types';

// ---------------------------------------------------------------------------
// Status config — colours per PRD §11
// ---------------------------------------------------------------------------

type StatusConfig = {
  label: string;
  variant: 'success' | 'warning' | 'destructive' | 'secondary' | 'outline';
  accent?: 'success' | 'warning' | 'destructive';
};

const STATUS_CONFIG: Record<DelegationStatus, StatusConfig> = {
  active: {
    label: 'Active',
    variant: 'success',
    accent: 'success',
  },
  expired: {
    label: 'Expired',
    variant: 'secondary',
  },
  revoked: {
    label: 'Revoked',
    variant: 'destructive',
    accent: 'destructive',
  },
};

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

interface DelegationStatusBadgeProps {
  status: DelegationStatus;
  className?: string;
}

export const DelegationStatusBadge: React.FC<DelegationStatusBadgeProps> = ({
  status,
  className,
}) => {
  const config = STATUS_CONFIG[status] ?? {
    label: status,
    variant: 'outline' as const,
  };

  return (
    <Badge
      variant={config.variant}
      accent={config.accent}
      className={className}
    >
      {config.label}
    </Badge>
  );
};
